import * as actionTypes from '../actionTypes';

const state = {
  isLoadingGetSingleSmsRecord: false,
  getSingleSmsRecordMessage: '',
  getSingleSmsRecordFailed: '',
};

const initializeStates = JSON.parse(JSON.stringify(state));

function SmsRecordReducer(globalstate = state, action) {
  switch (action.type) {
    case actionTypes.INITIALIZE_STATES_FULFILLED:
      return {
        ...initializeStates,
      };
    case actionTypes.GET_SINGLE_SMS_RECORD_PENDING:
      return {
        ...globalstate,
        isLoadingGetSingleSmsRecord: true,
      };
    case actionTypes.GET_SINGLE_SMS_RECORD_FULFILLED:
      return {
        ...globalstate,
        isLoadingGetSingleSmsRecord: false,
        getSingleSmsRecordMessage: action.data,
        getSingleSmsRecordFailed: '',
      };
    case actionTypes.GET_SINGLE_SMS_RECORD_FAILURE:
      return {
        ...globalstate,
        isLoadingGetSingleSmsRecord: false,
        getSingleSmsRecordMessage: '',
        getSingleSmsRecordFailed: action.error,
      };
    default:
      return globalstate;
  }
}

export { SmsRecordReducer as default };
